export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'



// WEBPACK FOOTER //
// ./src/store/modules/Auth/mutation-types.js